import type { EligibleTemplate } from 'tio-employee/services/reimagined-data';

/** Ordering offered by the Eligible Benefits sort control. */
export type EligibleSort = 'date' | 'alphabetical';

/**
 * Orders eligible benefits for display: enrolled programs first, then the rest,
 * with `sort` applied inside each group.
 *
 * `date` is newest-first on `createdAt`; a template without one (demo fixtures
 * carry no timestamp) falls to the end of its group rather than the top.
 * Returns a new array — the input is not mutated.
 */
export function sortEligibleTemplates(
  templates: EligibleTemplate[],
  sort: EligibleSort
): EligibleTemplate[] {
  const compare =
    sort === 'alphabetical'
      ? (a: EligibleTemplate, b: EligibleTemplate) => a.name.localeCompare(b.name)
      : (a: EligibleTemplate, b: EligibleTemplate) =>
          new Date(b.createdAt || 0).getTime() - new Date(a.createdAt || 0).getTime();

  const enrolled = templates.filter((template) => template.isEnrolled);
  const rest = templates.filter((template) => !template.isEnrolled);

  return [...enrolled.sort(compare), ...rest.sort(compare)];
}
